import "../../assets/css/login-box.css";
import { useState, useEffect } from "react";
import React from "react";
import CookieService from "../../services/CookieService";
import ChatService from "../../services/ChatService";
import { useHistory } from "react-router-dom";
import PublicCloudService from "../../public_cloud/services/service";
import UserService from "../../services/UserService";
import IBMService from "../../services/IBMService";
import OrganizationService from "../../services/OrganizationService";
import BlueMatadorService from "../../services/BlueMatadorService";
import CloudWatchService from "../../services/CloudWatchService";
import TrendMicroService from "../../services/TrendMicroService";
import PortalService from "../../services/PortalService";
import axios from "axios";
import { sortBy, compose, prop, toLower } from 'ramda';

import { appState } from "../../AppState";
import Enum from "../../utility/enum";
import {
  Button,
  Input,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Alert
} from "reactstrap";
import { parseQueryParams } from "../../utility/misc";
import BrowserSupport from "../../utility/BrowserSupport"
const Login = () => {
  const [stateApp, stateAppActions] = appState();

  const [errorVisible, setErrorVisible] = useState(false);
  const [inFlight, setInFlight] = useState(false);
  const [returnUrl, setReturnUrl] = useState();
  const [loginFlow, setLoginflow] = useState(null);
  const [showMfa, setShowMfa] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Invalid Username/Password");
  const history = useHistory();

  const [stateLocal, setLocalState] = useState({
    email: "",
    password: "",
    mfa: ""
  });

  useEffect(() => {
    var queryDict = parseQueryParams();
    setReturnUrl(queryDict["rurl"]);
  }, []);

  useEffect(() => {
    document.body.classList.add("background-blue");
    return () => document.body.classList.remove("background-blue");
  });

  const validateForm = () => {
    if (stateLocal.email && stateLocal.password) return true;
  };

  const setEmail = val => {
    setLocalState(values => ({ ...values, email: event.target.value }));
  };
  const setMfa = val => {
    setLocalState(values => ({ ...values, mfa: event.target.value }));
  };
  const setPassword = val => {
    setLocalState(values => ({ ...values, password: event.target.value }));
  };
  const doLogin = result => {
    return new Promise((resolve, reject) => {
      stateAppActions.setAuthenticated(result.data);
      resolve();
    });
  };
  async function determineClouds() {
    let ibmi = {}, params = {headers: {"x-auth-token": CookieService.getCookie("session_id")}};
    let cloud_types = await PublicCloudService.list_clouds(params);
    try {
      ibmi = await IBMService.hosts(params);
    } catch {
      ibmi = {data: []};
    }

    let types = [];
    for (var i = 0; i < cloud_types.data.clouds.length; i++) {
      if (cloud_types.data.clouds[i].cloud_type_id.includes("AWS")) {
        types.push(Enum.CloudCategory.AWS);
        types.push(Enum.CloudCategory.PUBLIC_CLOUD);
      }
      if (cloud_types.data.clouds[i].cloud_type_id.includes("AZURE")) {
        types.push(Enum.CloudCategory.AZURE);
        types.push(Enum.CloudCategory.PUBLIC_CLOUD);
      }
      if (cloud_types.data.clouds[i].cloud_type_id.includes("VMWARE")) {
        types.push(Enum.CloudCategory.VMWARE);
      }
    }
    if (ibmi.data.length > 0) types.push(Enum.CloudCategory.IBMI);

    stateAppActions.setClouds([...new Set(types)]);
    stateAppActions.setCloudAccounts(cloud_types.data.clouds);

    return new Promise(resolve => {
      resolve("resolved");
    });
  }

  async function determineOrgs() {
    try{
      let orgs = await OrganizationService.list_orgs({
        headers: {
          "x-auth-token": CookieService.getCookie("session_id")
        }
      });
      stateAppActions.setOrganizations(sortBy(compose(toLower, prop('name')))(orgs.data));
      return new Promise(resolve => {
        resolve("resolved");
      });
    }
    catch(ex){
      console.log(ex);
    }
  }

  async function determineIntegrations() {
    let integrations = [];
    try {
      let hasBlueMatador = await BlueMatadorService.checkSetup({
        headers: {
          "x-auth-token": CookieService.getCookie("session_id")
        }
      });
      if (hasBlueMatador.data.has_bluematador) integrations.push(Enum.Integration.BLUEMATADOR)

      let hasTrendMicro = await TrendMicroService.checkSetup({
        headers: {
          "x-auth-token": CookieService.getCookie("session_id")
        }
      });
      if (hasTrendMicro.data.has_trendmicro) integrations.push(Enum.Integration.TRENDMICRO)

      let cloudWatchAlarms = await CloudWatchService.getAlarms({
        headers: {
          "x-auth-token": CookieService.getCookie("session_id")
        }
      });
      if (cloudWatchAlarms.data.clouds_alarms_list.length > 0) integrations.push(Enum.Integration.CLOUDWATCH)

      stateAppActions.setIntegrations(integrations);
      return new Promise(resolve => {
        resolve("resolved");
      });
    }
    catch(ex) {
      console.log(ex);
    }
  }

  async function determineSkyLiftLink() {
    try{
      CookieService.eraseCookie("show_skylift", "/");
      let metadata = await PortalService.getPortalCustomerMeta({ meta_key: 'tria_show_skylift_link' }, {
        headers: {
          "x-auth-token": CookieService.getCookie("session_id")
        }
      });

      let show_skylift = metadata.meta_value == "TRUE" ? 1 : 0;
      CookieService.setCookie("show_skylift", show_skylift, 0, stateApp.env, '/');

      stateAppActions.setPortalCustomerMeta(metadata);
      return new Promise(resolve => {
        resolve("resolved");
      });
    }
    catch(ex){
      console.log(ex);
    }
  }

  async function determineUpsellsEnabled() {
    try{
      let metadata = {};
      let upsellsEnabled = CookieService.getCookie("tria_upsell_ads");
      if (!upsellsEnabled) {
        metadata = await PortalService.getPortalCustomerMeta({ meta_key: 'tria_upsell_ads' }, {
          headers: {
            "x-auth-token": CookieService.getCookie("session_id")
          }
        });
        CookieService.setCookie("tria_upsell_ads", metadata.meta_value, 0, stateApp.env, '/');
      } else {
        metadata = { meta_key: 'tria_upsell_ads', meta_value: upsellsEnabled };
      }

      stateAppActions.setPortalCustomerMeta(metadata);
      return new Promise(resolve => {
        resolve("resolved");
      });
    }
    catch(ex){
      console.log(ex);
    }
  }

  const showErrorMessage = msg => {
    setErrorMessage(msg);
    setErrorVisible(true);
    setTimeout(() => {
      setErrorVisible(false);
    }, 2000);
    setInFlight(false);
  };

  const handleSubmit = async e => {
    event.preventDefault();

    setInFlight(true);
    try {
      let result = null;
      switch (e.target.id) {
        case "userpass-submit":
          let userResult = await UserService.iniate(stateLocal.email);
          let passResult = await UserService.local_login(
            stateLocal.password,
            userResult.data.token
          );

          if (passResult.data.hasOwnProperty("user_id")) {
            result = passResult.data;
            break;
          }

          //otherwise mfa store above in state and send to mfa screen //return;
          setLoginflow(values => ({
            ...values,
            userResult: userResult.data,
            passResult: passResult.data,
            step: "v3_tfa_attempt"
          }));
          setInFlight(false);
          setShowMfa(true);
          return;

        case "mfa-submit":
          setInFlight(true);
          try {
            let mfaResult = await UserService.verify_mfa(
              stateLocal.mfa,
              loginFlow.passResult.token
            );
            if (!mfaResult.data.hasOwnProperty("user_id"))
              throw Error("Invalid Code");

            result = mfaResult.data;
            setInFlight(false);
          } catch (e) {
            showErrorMessage("Invalid MFA Token");

            return;
          }
          break;

        default:
          break;
      }

      if (typeof result == null) throw Error("Unauthorized");

      if (result.session_id) {
        axios.defaults.headers.common["x-auth-token"] = result.session_id;
        CookieService.setCookie(
          "session_id",
          result.session_id,
          1,
          stateApp.env, '/'
        );
        //CookieService.setCookie("session_timeout", result.data.session_timeout, 1, stateApp.env);
        //CookieService.setCookie("session_timeout_time",1573054868182, 1, stateApp.env);
        let user_info = await UserService.user_info({
          headers: {
            "x-auth-token": CookieService.getCookie("session_id")
          }
        });

        let session_timeout_time = await UserService.get_session_timeout_time();
        var d = Date.parse(session_timeout_time.data.expiration);
        CookieService.setCookie("session_timeout_time", d, 1, stateApp.env);
        stateAppActions.setSessionTimeoutTime(d);

        await Promise.all([
          determineClouds(),
          determineOrgs(),
          determineIntegrations(),
          determineSkyLiftLink(),
          determineUpsellsEnabled(),
        ])
        .then() // 1,Error: 2,3
        .catch(e => console.log(e));

        //determin what clouds a customer has
        await doLogin(user_info);
        ChatService.getChatCustomer(result.user_name);
        setInFlight(false);

        if (returnUrl != null) {
          history.push(returnUrl);
        } else {
          history.push("/app/dashboard");
        }
      }
    } catch (error) {
      console.log(error);
      showErrorMessage("Invalid Username/Password");
    }
  };

  return (
    <>
    <BrowserSupport></BrowserSupport>
      <Alert
        color="danger"
        className={"alert " + (errorVisible ? "alert-shown" : "alert-hidden")}
        isOpen={errorVisible}
        toggle={e => setErrorVisible(false)}
      >
        {errorMessage}
      </Alert>
      <div className="container">
        <div className="Login mr-auto ml-auto">
          <Card
            className="card-chart mr-3 ml-3 card-white"
            style={{ width: "unset" }}
          >
            <CardBody>
              <div className="text-center mb-3 mt-2">
                <img
                  width="128px"
                  alt="Connectria"
                  className="login-logo"
                  src="data:image/png;base64,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"
                  // src={require("../../assets/img/connectria-logo.svg")}
                />
              </div>
              {stateLocal.visible}
              {showMfa ? (
                <MfaForm
                  stateLocal={stateLocal}
                  handleSubmit={handleSubmit}
                  setMfa={setMfa}
                  validateForm={validateForm}
                ></MfaForm>
              ) : (
                <form onSubmit={handleSubmit}>
                  {showForgotPassword ? (
                    <ForgotPasswordScreen
                      setShowForgotPassword={setShowForgotPassword}
                    ></ForgotPasswordScreen>
                  ) : (
                    <div>
                      <label>Username</label>
                      <Input
                        autoFocus
                        type="text"
                        name="username"
                        id="username"
                        value={stateLocal.email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="Enter Username"
                      />

                      <label>Password</label>
                      <Input
                        value={stateLocal.password}
                        onChange={e => setPassword(e.target.value)}
                        type="password"
                        name="password"
                        id="password"
                        placeholder="Enter Password"
                      />
                      <div className="text-right">
                        <a href="#" onClick={() => setShowForgotPassword(true)}>
                          Forgot your password?
                        </a>
                      </div>

                      <Button
                        block
                        className="mt-3"
                        id="userpass-submit"
                        disabled={!validateForm() || inFlight}
                        onClick={handleSubmit}
                        type="submit"
                      >
                        Login
                      </Button>
                    </div>
                  )}
                </form>
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};
const ForgotPasswordScreen = props => {
  return (
    <div>
      <p>
        For your convenience Portal and TRiA use the same password. To reset
        your Portal password click the link below.{" "}
      </p>
      {/* <ol>
  <li>Click the link to reset password.</li>
  <li>A "Password pass phrase" will be displayed on the screen (note the phrase). An email will be sent.</li>
  <li>Open "Connectria Portal Password Reset" email and click the link to reset your password. You will be required to enter the "Password Pass phrase".</li>
  <li>Password Must Contain all the following: 10 -40 characters at least 1 upper-case character at least 1 number at least 1 special character.</li>
</ol> */}
      <p className="pb-2">
        <a
          href="https://www.mh.connectria.com/account/forgotpassword"
          target="_blank"
        >
          Click Here To Reset Password
        </a>
      </p>
      <p className="lead">
      If you have any questions please feel free to reach out to us via Chat located in the lower right area of the screen or call <a href="tel:+18007817178">+1-800-781-7178 </a>
      or email us at <a href="mailto:support@connectria.com">support@connectria.com <i className="fa fa-envelope" aria-hidden="true"></i>.</a>
      </p>
      <br></br>
      <a href="#" onClick={() => props.setShowForgotPassword(false)}>
        <i className="fas fa-arrow-circle-left"></i> Back To Login
      </a>
    </div>
  );
};
const MfaForm = props => {
  return (
    <form onSubmit={props.handleSubmit}>
      <label>MFA Token</label>
      <Input
        autoFocus
        type="input"
        pattern="\d{1,5}"
        value={props.stateLocal.mfa}
        onChange={e => props.setMfa(e.target.value)}
        placeholder="Enter MFA"
      />
      <Button
        block
        className="mt-3"
        disabled={!props.validateForm() || props.inFlight}
        onClick={props.handleSubmit}
        id="mfa-submit"
        type="submit"
      >
        Submit
      </Button>
    </form>
  );
};

export default Login;
